import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react'
import DropDown from '../dropdown';
import PropTypes from "prop-types";
import { Rates } from '../../../api/services/next';
import { useTextResources } from '../../../language';
import _ from 'lodash'

const RatesDropDown = ({ HotelId, HotelIds, spec: externalSpec, data, onChangeItem, onClose, ...props }) => {
  const text = useTextResources();
  const [searchText, setSearchText] = useState('')
  const selectedItemsRef = useRef([]);

  const inheritanceDescription = useCallback((item) => {
    return item.BaseRateId ? text("Inherits") : undefined;
  }, []);

  const spec = useMemo(() => {
    const s = HotelIds ? { HotelIds } : { HotelId };
    if (searchText) {
      s.RateName = searchText;
    }
    return { ...externalSpec, ...s };
  }, [HotelId, HotelIds, searchText, externalSpec]);

  const onSearchChange = useMemo(() => _.debounce((value) => {
    setSearchText(value)
  }, 400), []);

  useEffect(() => {
    return () => { onSearchChange.cancel(); };
  }, [onSearchChange]);

  const handleClose = useCallback(() => {
    onSearchChange.cancel();
    setSearchText('');
    onClose?.();
  }, [onClose, onSearchChange]);

  const handleChangeItem = useCallback((items) => {
    if (Array.isArray(items)) {
      selectedItemsRef.current = items;
    } else if (items) {
      selectedItemsRef.current = [items];
    } else {
      selectedItemsRef.current = [];
    }
    onChangeItem?.(items);
  }, [onChangeItem]);

  return <DropDown {...props} data={searchText ? undefined : data} api={Rates.GetRates} spec={spec} textField="Name" valueField="Id" descriptionField={inheritanceDescription} onSearchChange={onSearchChange} onClose={handleClose} onChangeItem={handleChangeItem} selectedItems={selectedItemsRef.current} />
}

RatesDropDown.propTypes = {
  HotelId: PropTypes.any,
  HotelIds: PropTypes.any
}

export default RatesDropDown